import { drawerAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { colors } from "../tokens/colors";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  dialog: {
    bg: colors.neutral["900"],
  },
  header: {
    bg: colors.neutral["900"],
    color: "white",
  },
  body: {
    bg: colors.neutral["900"],
    color: "white",
  },
  closeButton: {
    color: "white",
  },
});

export default defineMultiStyleConfig({
  baseStyle,
});
